import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from '../../components/Modal';
import * as familyspaceActions from '../../actions/familySpaceActions';
import {  Button } from 'reactstrap';
import history from "../../history";
import folder from '../../images/space/001-folder.svg';
import family2 from '../../images/space/003-family-2.svg';
import compar from '../../images/space/Soustraction4.svg';
import invite from '../../images/space/user.svg';
import disconnect from '../../images/space/XMLID_2_.svg';
import {Sinvite} from "./Sinvite";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from '@material-ui/icons/Close';
import MediaQuery from "react-responsive";
import {gtmFamily} from "../../services/gtmFamily"


class SMenuComponent extends Component {
  state = {
    displayInvite: false,
    dropdownOpen:false,
    activeIndex:0,
    displayActivate: false,
    collapseMenu: false
  };

  handleClickOutsideDisplayInvite = (event)=>{
    if (this.state.displayInvite === false){
      return;
    }
    const domNode = ReactDOM.findDOMNode(this);
    
    if (!domNode || !domNode.contains(event.target)) {
        if (event.target.contains(document.getElementById('modalInviteId'))){
          
          this.setState({
            displayInvite: false
        });
        
        }
    } 
}
  
  displayMenu () {
    const { user } = this.props.familySpace;
    const { fontColor } = this.props.adminConfig.config
    return ( [
      {icon:folder,text:"Nos projets",action:() => this.golink(`/famille/${this.props.client}/familyspace/projects`), content:`<svg xmlns="http://www.w3.org/2000/svg" width="22" height="17.397" viewBox="0 0 22 17.397"><defs><style>.svg-folder{fill:${fontColor && fontColor};</style></defs><g transform="translate(0 -42.679)"><g transform="translate(0 44.978)"><g transform="translate(0 0)"><path class="svg-folder" d="M17.9,87.292H9.965L8.386,85.416a.27.27,0,0,0-.216-.1h-6.4A1.779,1.779,0,0,0,0,87.1V98.639a1.779,1.779,0,0,0,1.777,1.777H17.9a1.779,1.779,0,0,0,1.777-1.777v-9.57A1.779,1.779,0,0,0,17.9,87.292Z" transform="translate(0 -85.319)"/></g></g><g transform="translate(2.34 42.679)"><g transform="translate(0 0)"><path class="svg-folder" d="M61.293,44.652H53.354l-1.579-1.876a.27.27,0,0,0-.216-.1h-6.4A1.777,1.777,0,0,0,43.4,44.214h5.839a1.033,1.033,0,0,1,.794.369l1.348,1.6h7.581A2.545,2.545,0,0,1,61.5,48.727v9.033A1.777,1.777,0,0,0,63.06,56v-9.57A1.779,1.779,0,0,0,61.293,44.652Z" transform="translate(-43.4 -42.679)"/></g></g></g></svg>`},
      {icon:compar,text:"Comparateur",action:() => this.golink(`/famille/${this.props.client}/familyspace/projects/compare`), content:`<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><defs><style>.svg-compar{fill:${fontColor && fontColor};</style></defs><path class="svg-compar" d="M-5660-730a11.012,11.012,0,0,1-11-11,11.012,11.012,0,0,1,11-11,11.012,11.012,0,0,1,11,11A11.012,11.012,0,0,1-5660-730Zm-6.292-8.094a.582.582,0,0,0-.58.583.581.581,0,0,0,.58.581h11.392l-2.5,2.5a.585.585,0,0,0,0,.824.574.574,0,0,0,.413.172.573.573,0,0,0,.412-.172l3.491-3.489a.583.583,0,0,0,.171-.411.584.584,0,0,0-.171-.413l-3.491-3.489a.587.587,0,0,0-.412-.172.588.588,0,0,0-.413.172.584.584,0,0,0-.171.411.592.592,0,0,0,.171.413l2.5,2.5Zm3.49-10.47a.58.58,0,0,0-.411.17l-3.491,3.489a.592.592,0,0,0-.17.413.593.593,0,0,0,.17.413l3.491,3.489a.576.576,0,0,0,.411.17.579.579,0,0,0,.413-.17.576.576,0,0,0,.17-.412.577.577,0,0,0-.17-.412l-2.5-2.5h11.392a.582.582,0,0,0,.581-.581.582.582,0,0,0-.581-.581h-11.392l2.5-2.5a.594.594,0,0,0,.17-.411.6.6,0,0,0-.17-.413A.579.579,0,0,0-5662.8-748.563Z" transform="translate(5671.001 752)"/></svg>`},
      {icon:family2,text:"Ma famille",action:() => this.golink(`/famille/${this.props.client}/familyspace/myFamily`), content:`<svg xmlns="http://www.w3.org/2000/svg" width="25.173" height="21.25" viewBox="0 0 25.173 21.25"><defs><style>.svg-family2{fill:${fontColor && fontColor};</style></defs><g transform="translate(16.426 4.265)"><g transform="translate(0 0)"><path class="svg-family2" d="M342.8,128.618a1.983,1.983,0,0,0-1.979-1.969h-4.186a2.285,2.285,0,0,0-2.011,1.2l-.291.537a2.222,2.222,0,0,1-.251,2.167,2.2,2.2,0,0,1,.844.247l1.168-2.154a.135.135,0,0,1,.254.064v13.919a1,1,0,1,0,2.007,0v-8.019h.433v8.02a1,1,0,0,0,2.007,0c0-12.956-.018-6.093-.018-14a.175.175,0,0,1,.35,0l.031,6.143a.836.836,0,0,0,.836.832h0a.836.836,0,0,0,.832-.84Z" transform="translate(-334.086 -126.649)"/></g></g><g transform="translate(0 4.056)"><path class="svg-family2" d="M17.666,128.7a1.431,1.431,0,0,0-1.428-1.421H13a1.431,1.431,0,0,0-1.428,1.421c0,.244,0,.036-.007,1.185l-.665-.137s-1.489-4.1-2.022-5.648c-.392-1.139-1.048-1.717-1.951-1.717H4c-.9,0-1.56.578-1.951,1.717-.607,1.766-1.985,5.536-2,5.574a.844.844,0,0,0,1.585.58c.012-.032,1-2.739,1.677-4.653-.045.371.1-.41-1.2,6.284a.47.47,0,0,0,.46.559H3.22v6.121a1.013,1.013,0,1,0,2.025,0v-6.121h.437v6.121a1.013,1.013,0,1,0,2.025,0v-6.121h.644a.469.469,0,0,0,.46-.559c-1.3-6.695-1.153-5.913-1.2-6.284.676,1.913,1.665,4.621,1.677,4.653a.844.844,0,0,0,.761.553l1.99.409a.6.6,0,0,0,.725-.587s.01-1.695.011-1.9a.116.116,0,0,1,.233,0c0,1.626,0,9.441,0,10.117a.724.724,0,0,0,1.448,0v-5.788h.313v5.788a.724.724,0,0,0,1.448,0c0-4.162-.01-9.056-.013-10.143a.126.126,0,0,1,.252,0l.022,4.433a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6v0C17.684,132.212,17.67,129.528,17.666,128.7Z" transform="translate(0 -122.383)"/></g><g transform="translate(19.194 0.044)"><g transform="translate(0 0)"><circle class="svg-family2" cx="1.733" cy="1.733" r="1.733"/></g></g><g transform="translate(13.05 5.288)"><g transform="translate(0 0)"><circle class="svg-family2" cx="1.573" cy="1.573" r="1.573"/></g></g><g transform="translate(3.714 0)"><path class="svg-family2" d="M77.3,39.9a1.749,1.749,0,1,0,1.749,1.749A1.749,1.749,0,0,0,77.3,39.9Z" transform="translate(-75.548 -39.898)"/></g></svg>`},
      // {icon:money,text:"Cagnotte familiale",action:()=> this.props.display("pot")},
      {icon:invite,text:"Inviter un proche",action: () => user.activated ? this.setState({displayInvite:true,collapseMenu:false}) : this.setState({displayActivate: true,collapseMenu:false}), content:`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="18.182" viewBox="0 0 25 18.182"><defs><style>.svg-invite{fill:${fontColor && fontColor};</style></defs><g transform="translate(0 -64)"><g transform="translate(0 64)"><g transform="translate(0 0)"><path class="svg-invite" d="M137.091,277.333c-3.028,0-9.091,1.517-9.091,4.545v2.273h18.182v-2.273C146.182,278.85,140.119,277.333,137.091,277.333Z" transform="translate(-121.182 -265.969)"/><path class="svg-invite" d="M217.879,73.091a4.545,4.545,0,1,0-4.545-4.545A4.548,4.548,0,0,0,217.879,73.091Z" transform="translate(-201.97 -64)"/><path class="svg-invite" d="M9.091,131.409H5.682V128H3.409v3.409H0v2.273H3.409v3.409H5.682v-3.409H9.091Z" transform="translate(0 -124.591)"/></g></g></g></svg>`},
      {icon:disconnect,text:"Déconnexion",action: () => {this.props.familySpaceAction.logout(); history.push(`/famille/${this.props.client}`)}, content:`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="18.591" viewBox="0 0 25 18.591"><defs><style>.svg-disconnect{fill:${fontColor && fontColor};</style></defs><g transform="translate(0 -42.299)"><path class="svg-disconnect" d="M3.88,110.682H17.045a1.136,1.136,0,1,0,0-2.273H3.88l1.469-1.469a1.136,1.136,0,1,0-1.607-1.607L.333,108.742c-.026.026-.051.054-.075.083l-.016.022c-.017.022-.034.044-.05.067l-.013.021c-.016.024-.031.049-.045.075l-.007.016c-.014.028-.028.056-.04.085l0,.011c-.012.031-.024.062-.033.093,0,0,0,.008,0,.012-.009.031-.018.063-.024.1,0,.01,0,.02,0,.029,0,.027-.009.054-.012.081a1.121,1.121,0,0,0,0,.227c0,.028.008.055.012.082,0,.009,0,.019,0,.028.007.033.015.065.024.1l0,.011c.01.032.021.063.034.094l0,.01c.012.029.026.058.04.086l.007.015c.014.026.029.051.045.075l.012.02c.016.023.033.046.05.068l.016.022c.024.029.049.056.075.083l3.409,3.409a1.136,1.136,0,0,0,1.607-1.607Z" transform="translate(0 -57.951)"/><path class="svg-disconnect" d="M110.758,42.3a9.289,9.289,0,0,0-7.72,4.116,1.136,1.136,0,0,0,1.886,1.268,7.023,7.023,0,1,1,.009,7.838,1.136,1.136,0,0,0-1.883,1.272A9.3,9.3,0,1,0,110.758,42.3Z" transform="translate(-95.054 0)"/></g></svg>`}
    ])
  }
  renderMenu = (menu,activeIndex) => {
    return menu.map((item, index) =>
      <div className={activeIndex === index ? "actionMenu active" : "actionMenu"} key={index}
           onClick={() => {
             this.gtmAction(item.text);
             item.action();
             this.setState({activeIndex: index})
           }}>
        <span dangerouslySetInnerHTML={{ __html: item.content }} /> &nbsp;
        {/* <img src={item.icon} alt={item.text}/> */}
        <span>{item.text}</span>
      </div>)
  }
  collapseMenu = ()=> {
    this.setState({collapseMenu: !this.state.collapseMenu})
  }
  
  gtmAction = id => {
    let obj = {
      category: "espace famille",
      type: "cta",
      from: "menu"
    }
    let subtemplate = "";
    switch (id) {
      case "Nos projets":
        obj = {
          ...obj,
          name: "nos projets",
          subcategory: "liste projets",
        }
        subtemplate = "liste projets";
        break;
      case "Comparateur":
        obj = {
          ...obj,
          name: "comparateur",
          subcategory: "comparateur",
        }
        subtemplate = "comparateur";
        break;
      case "Ma famille":
        obj = {
          ...obj,
          name: "ma famille",
          subcategory: "ma famille",
        }
        subtemplate = "ma famille";
        break;
      case "Inviter un proche":
        obj = {
          ...obj,
          name: "inviter un proche",
          subcategory: "popup demander un devis",
        }
        subtemplate = "inviter un proche";
        break;
      case "Déconnexion":
        obj = {
          ...obj,
          name: "déconnexion",
          subcategory: "login",
        }
        break;
    }

    // send event
    gtmFamily().ctaOfConfiguration(obj, { template: "espace famille", subtemplate: subtemplate })
  }

  golink(link){
    // 
    history.push(link);
    this.collapseMenu()
  }
  addArchivePath = () => {
    let path = window.location.href
    return path.includes('archive') ? '/archive' : ''
  };
  render() {
    const menu = this.displayMenu();
    const { displayInvite, activeIndex, displayActivate, collapseMenu} = this.state;
    const { client, familySpace } = this.props;
    if(!this.state.displayInvite){
      document.addEventListener('mousedown', this.handleClickOutsideDisplayInvite);
    }
    const {colorConfig} = this.props;
    return(
      <div className="Smenu" style={{ "--f-main-color": colorConfig && colorConfig.mainColor, "--f-font-color": colorConfig && colorConfig.fontColor }}>
        <MediaQuery minWidth={577}>{this.renderMenu(menu,activeIndex)}</MediaQuery>
        <MediaQuery maxWidth={576}>
          <div className="Smenu-nav d-flex" onClick={()=>this.collapseMenu()} >
            {!collapseMenu
              ? <MenuIcon className="material-icons Smenu-nav-burger" style={{"--f-font-color":colorConfig && colorConfig.fontColor}}></MenuIcon>
              : <CloseIcon className="material-icons Smenu-nav-burger" style={{"--f-font-color":colorConfig && colorConfig.fontColor}}></CloseIcon>
            }
            <p className="Smenu-nav-text" style={{"--f-font-color":colorConfig && colorConfig.fontColor}}>Menu</p>
          </div>
          <div 
            className={collapseMenu ? "collapsed-menu move" : "collapsed-menu"}
            style={{ "--f-main-color": colorConfig && colorConfig.mainColor, "--f-font-color": colorConfig && colorConfig.fontColor }}
          >
            {this.renderMenu(menu, activeIndex)}
          </div>
        </MediaQuery>

        {displayInvite && <Sinvite className="blurBackground" close={()=>this.setState({displayInvite:false})}/>}

        <Modal
          isOpen={displayActivate}
          onRequestClose={() => this.setState({displayActivate: false})}
          className="familyspace-addQuote-modal family-space-form"
          overlayClassName="familyspace-member-name-modal-overlay familyspace-login-modal-overlay"
        >
          <h2 className="title">Vous devez activer votre compte avant de pouvoir inviter un proche.</h2>

          <div className="block actions">
            <Button className="add" onClick={() => history.push(`/famille/${client}/familyspace/renew?mail_token=${familySpace.user.token_mail}`)}>Activer</Button>
            <Button className="cancel" onClick={() => this.setState({displayActivate: false})}>Annuler</Button>
          </div>
        </Modal>

      </div>)
  }
};

export const SMenu = connect(state => ({
  familySpace: state.familyService,
  adminConfig: state.adminConfig
}), dispatch => ({
  familySpaceAction: bindActionCreators(familyspaceActions, dispatch),
}))(SMenuComponent);

